module.exports = __webpack_public_path__ + "img/Corporate.4bddfd6d.webp";